export default class SideNav {
    sidenavElements = document.querySelectorAll('input[type="checkbox"][data-sidenav]');
    engineElements = document.querySelectorAll('label[for="engineonboarding"]');
    constructor(){
        this.init()
    }

    init():void {
        for(let i=0; i < this.sidenavElements.length; i++) {
            this.sidenavElements[i].addEventListener("click", ()=> { 
                setTimeout(()=> {
                    this.checkBodyFixed(this.sidenavElements[i])
                },200) 
            })
        }
        let inputContract: HTMLInputElement;
        PubSub.subscribe("selector-loaded.enginec",()=>{
            inputContract = document.querySelector('[name=enginec]')?.nextElementSibling as HTMLInputElement;
        })
        for(let i=0; i < this.engineElements.length; i++) {
            this.engineElements[i].addEventListener("click", (event)=> { 
                // in mobile tunnel "return" label in contract facet is also engineElement and we want the contract facet to close only, not the whole tunnel
                if(inputContract?.checked) {
                    event.preventDefault()
                    inputContract.checked = false;
                    return false;
                }
                setTimeout(()=> {
                    this.checkBodyFixed(this.engineElements[i])
                },200) 
            })
        }
    }

    checkBodyFixed(element: any):void {
        if(element.nodeName !== "INPUT") {
            const id = element.htmlFor;
            element = document.getElementById(id);
        }
        if(element.checked) {
            document.querySelector('body').classList.add("fixed");
            document.querySelector('html').classList.add("fixed");
        } else {
            document.querySelector('body').classList.remove("fixed");
            document.querySelector('html').classList.remove("fixed");
        }
    }
}